import { post } from '../../api';

export const postDuplicacao = (data) => {
  return post('/api/conectores/duplicacao', data);
};
